import { render, staticRenderFns } from "./Asset-Overview-Transformation.vue?vue&type=template&id=3b64f1dd&scoped=true&lang=pug"
import script from "./Asset-Overview-Transformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./Asset-Overview-Transformation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Asset-Overview-Transformation.vue?vue&type=style&index=0&id=3b64f1dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b64f1dd",
  null
  
)

export default component.exports